import { render } from "./loader-item.vue?vue&type=template&id=2781a522&scoped=true"
import script from "./loader-item.vue?vue&type=script&lang=js"
export * from "./loader-item.vue?vue&type=script&lang=js"

import "./loader-item.vue?vue&type=style&index=0&id=2781a522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2781a522"]])

export default __exports__